module.exports = __webpack_public_path__ + "static/media/match.346e997e.png";